import { useEffect } from 'react';

import {
  accountHomeBaseUrl,
  loginServerBaseUrl,
  loginServerTenantID,
  loginWebComponentUrl,
} from '@consumer-frontend/nc-api';

import { NcWebComponent } from '../NcWebComponent/NcWebComponent';

import '@consumer-bootstrap/brands/netcredit/apply/login-page-web-component.scss';

type EventHandlerT = (e: Event) => void;

type LoginPageEventHandlersT = {
  onLoginFlowRestarted?: EventHandlerT;
  onLoginMFAError?: EventHandlerT;
  onLoginMFASuccess?: EventHandlerT;
  onLoginSendMFAError?: EventHandlerT;
  onLoginSendMFASuccess?: EventHandlerT;
  onSubmitLoginCaptchaError?: EventHandlerT;
  onSubmitLoginError?: EventHandlerT;
  onSubmitLoginMFARequired?: EventHandlerT;
  onSubmitLoginSuccess?: EventHandlerT;
};

type NcLoginPageWebComponentPropsT = {
  code?: string;
  eventHandlers?: LoginPageEventHandlersT;
  loginLabel?: string;
  userEmail?: string;
};

export type NcLoginPageWebComponentT = React.FC<NcLoginPageWebComponentPropsT>;

const WEB_COMPONENT_URL = loginWebComponentUrl;
const CAPTCHA_ENGINE = import.meta.env.VITE_LOGIN_CAPTCHA_ENGINE || 'recaptcha';
const CAPTCHA_KEY = import.meta.env.VITE_LOGIN_CAPTCHA_KEY || '';
const TENANT_ID = loginServerTenantID;
const FORGOT_PASSWORD_URL = `${accountHomeBaseUrl}/password_resets/new`;
const REDIRECT_URI = `${accountHomeBaseUrl}/oauth2_redirect_apply`;
const SERVER_BASE_URL = loginServerBaseUrl;
const RESPONSE_MODE = import.meta.env.VITE_LOGIN_RESPONSE_MODE || 'form_post';

/* currently unused but configurable if needed: */
const FINGERPRINT_ENDPOINT = import.meta.env.VITE_LOGIN_FINGERPRINT_ENDPOINT || '';
const FINGERPRINT_KEY = import.meta.env.VITE_LOGIN_FINGERPRINT_KEY || '';
const FINGERPRINT_SCRIPT_URL_PATTERN = import.meta.env.VITE_LOGIN_FINGERPRINT_SCRIPT_URL_PATTERN || '';
const EDIT_EMAIL_REDIRECT_URL = import.meta.env.VITE_LOGIN_EDIT_EMAIL_REDIRECT_URL || '';

export const NcLoginPageWebComponent: NcLoginPageWebComponentT = ({
  code = '',
  loginLabel = 'Sign In',
  eventHandlers = {},
  userEmail = '',
}) => {
  useEffect(() => {
    Object.entries(eventHandlers).forEach(([key, value]) => {
      if (typeof value === 'function') {
        window.addEventListener(key, value);
      }
    });

    return () => {
      Object.entries(eventHandlers).forEach(([key, value]) => {
        window.removeEventListener(key, value);
      });
    };
  }, [eventHandlers]);

  const redirectUrl = new URL(REDIRECT_URI);

  redirectUrl.searchParams.set('signin_verification_code', code);

  return (
    <NcWebComponent
      src={WEB_COMPONENT_URL}
      tagName="login-page"
      componentProps={{
        'captcha-engine': CAPTCHA_ENGINE,
        'captcha-key': CAPTCHA_KEY,
        'edit-email-redirect-url': EDIT_EMAIL_REDIRECT_URL,
        'fingerprint-endpoint': FINGERPRINT_ENDPOINT,
        'fingerprint-key': FINGERPRINT_KEY,
        'fingerprint-script-url-pattern': FINGERPRINT_SCRIPT_URL_PATTERN,
        'forgot-password-url': FORGOT_PASSWORD_URL,
        id: 'login-page',
        'login-label': loginLabel,
        'login-server-uri': SERVER_BASE_URL,
        'redirect-uri': redirectUrl.toString(),
        'response-mode': RESPONSE_MODE,
        'tenant-id': TENANT_ID,
        'user-email': userEmail,
      }}
    />
  );
};
